import { store } from '@/store'
import localStorageService from '@/core/local-storage'

/* Auth & Route Guard access control - to prevent user for navigation to not-allowed routes */
export default async (to, from, next) => {
  // set page title
  if (to.name !== 'Book' && to.name !== 'Share' && to.name !== 'TeamBook') document.title = to.meta.title

  const token = store.state.auth.token

  /* Setting token when we redirecting from old site */
  if (to.name === 'SocialAuthSuccess') {
    store.dispatch('socialLogin')
    return next()
  }

  if (to.name !== 'Books' && to.name !== 'TeamBooks' && to.name !== 'Book' && to.name !== 'TeamBook' && to.name !== 'Login') localStorageService.removeItem('lastOpenedProject', 'guard')

  /* removing the token from the localeStore when we go to the login page */
  if (to.name === 'Login' || to.name?.includes('SignUp')) {
    store.dispatch('logoutRedirect', next)
    store.commit('resetSettings')
    return false
  }

  /* if there is no token in localStorage */
  if (!token && !to.name?.includes('SignUp') && to.name !== 'ResetPassword' && to.name !== 'PasswordRecover' && to.name !== 'SocialAuthFailed' && to.name !== 'Share') {
    return next({ name: 'Login', params: { savedUrl: to.fullPath } })
  }

  next()
}
